var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 64.6224C91 44.8717 91 31.7983 91 12.0476C91 10.2699 89.5888 9 87.9209 9H21.0791C19.283 9 18 10.3968 18 12.0476V99.9524C18 101.73 19.4112 103 21.0791 103H68.248",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89 16.5348V67.3294C72.5 68 67.1847 81.4016 67.0406 89.92C66.9527 95.1094 69.1894 99 69.1894 99L25.4407 98.9082C24.5473 98.9064 23.7013 98.5064 23.1328 97.8173L22.6858 97.2754C22.2425 96.7379 22 96.063 22 95.3663V88.9163L87.5091 51.7795V13L89 16.5348Z",
    fill: "currentColor",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9857 96H24.0453C23.392 96 23 95.4886 23 94.9772L23 14.015C45.4738 14.0023 55.5262 13.9886 78 14.0154V45.5469",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 13C88 13 88 22.6463 87.332 50.0836C87.332 50.3411 87.332 50.541 87.332 50.541C85.3905 81.9591 56.4188 88.7124 53.0536 89.0987C51.5004 89.2274 48.5235 89.485 43.2168 89.485C36.6158 89.7425 26.5202 89.8712 10.7296 90C10.2118 90 9.82353 89.485 10.0824 88.9699C20.9546 67.209 21.0841 13.1288 21.0841 13.1288L88 13Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34L57 34",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61 34H67",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29H77",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5381 35C32.2944 35 32.0508 34.8989 31.8071 34.6968L28.2741 31.8664C27.9086 31.5632 27.9086 30.9567 28.2741 30.6534C28.6396 30.3502 29.3706 30.3502 29.736 30.6534L32.5381 32.9783L38.264 28.2274C38.6294 27.9242 39.3604 27.9242 39.7259 28.2274C40.0914 28.5307 40.0914 29.1372 39.7259 29.4404L33.269 34.7978C33.0254 34.8989 32.7817 35 32.5381 35Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52H62",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44 48H76",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5381 53C31.2944 53 31.0508 52.8989 30.8071 52.6968L27.2741 49.8664C26.9086 49.5632 26.9086 48.9567 27.2741 48.6534C27.6396 48.3502 28.3706 48.3502 28.736 48.6534L31.5381 50.9783L37.264 46.2274C37.6294 45.9242 38.3604 45.9242 38.7259 46.2274C39.0914 46.5307 39.0914 47.1372 38.7259 47.4404L32.269 52.7978C32.0254 52.8989 31.7817 53 31.5381 53Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40 72H48",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51 72L72 72",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68H72",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9162 74C28.6523 74 28.3883 73.8845 28.1244 73.6534L24.297 70.4188C23.901 70.0722 23.901 69.3791 24.297 69.0325C24.6929 68.6859 25.4848 68.6859 25.8807 69.0325L28.9162 71.6895L35.1193 66.2599C35.5152 65.9134 36.3071 65.9134 36.703 66.2599C37.099 66.6065 37.099 67.2996 36.703 67.6462L29.7081 73.769C29.4442 73.8845 29.1802 74 28.9162 74Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69 9.33321V13.535C69 13.783 69 13.9071 69 14.1551C68.6329 16.2636 66.9198 18 64.7173 18H44.2827C42.0802 18 40.3671 16.2636 40 14.1551C40 13.9071 40 13.783 40 13.535V9.33321C40 8.83709 40.3671 8.21695 40.9789 8.21695H51.0127C51.0127 7.9689 51.0127 7.84487 51.0127 7.72084C51.0127 5.73639 52.7257 4 54.6835 4C56.6413 4 58.3544 5.73639 58.3544 7.72084C58.3544 7.9689 58.3544 8.09293 58.3544 8.21695H68.3882C68.6329 8.34098 69 8.71307 69 9.33321Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69 9.33321V13.535C69 13.783 69 13.9071 69 14.1551C68.6329 16.2636 66.9198 18 64.7173 18H44.2827C42.0802 18 40.3671 16.2636 40 14.1551C40 13.9071 40 13.783 40 13.535V9.33321C40 8.83709 40.3671 8.21695 40.9789 8.21695H51.0127C51.0127 7.9689 51.0127 7.84487 51.0127 7.72084C51.0127 5.73639 52.7257 4 54.6835 4C56.6413 4 58.3544 5.73639 58.3544 7.72084C58.3544 7.9689 58.3544 8.09293 58.3544 8.21695H68.3882C68.6329 8.34098 69 8.71307 69 9.33321Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 10C55.3571 10 56 9.35714 56 8.5C56 7.64286 55.3571 7 54.5 7C53.6429 7 53 7.64286 53 8.5C53 9.35714 53.75 10 54.5 10Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71C85.4399 71 81.9598 72.0557 78.9997 74.0335C76.0397 76.0114 73.7326 78.8226 72.3702 82.1117C71.0078 85.4008 70.6513 89.02 71.3459 92.5116C72.0404 96.0033 73.7547 99.2106 76.2721 101.728C78.7894 104.245 81.9967 105.96 85.4884 106.654C88.98 107.349 92.5992 106.992 95.8883 105.63C99.1774 104.267 101.989 101.96 103.966 99.0003C105.944 96.0402 107 92.5601 107 89C107 86.6362 106.534 84.2956 105.63 82.1117C104.725 79.9278 103.399 77.9435 101.728 76.2721C100.056 74.6006 98.0722 73.2748 95.8883 72.3702C93.7044 71.4656 91.3638 71 89 71Z",
    fill: "currentColor",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71C85.4399 71 81.9598 72.0557 78.9997 74.0335C76.0397 76.0114 73.7326 78.8226 72.3702 82.1117C71.0078 85.4008 70.6513 89.02 71.3459 92.5116C72.0404 96.0033 73.7547 99.2106 76.2721 101.728C78.7894 104.245 81.9967 105.96 85.4884 106.654C88.98 107.349 92.5992 106.992 95.8883 105.63C99.1774 104.267 101.989 101.96 103.966 99.0003C105.944 96.0402 107 92.5601 107 89C107 86.6362 106.534 84.2956 105.63 82.1117C104.725 79.9278 103.399 77.9435 101.728 76.2721C100.056 74.6006 98.0722 73.2748 95.8883 72.3702C93.7044 71.4656 91.3638 71 89 71Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104 89.9346C103.898 89.9365 103.795 89.9374 103.693 89.9374C94.6737 89.9374 87.2888 82.9058 86.67 74C79.4911 75.1324 74 81.3759 74 88.9084C74 97.2432 80.7234 104 89.0171 104C96.9676 104 103.475 97.7909 104 89.9346Z",
    fill: "currentColor",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8277 83.218L97.1159 83.9204L97.8277 83.218C96.9366 82.3149 95.4789 82.3149 94.5878 83.218L86.9654 90.9433L84.4122 88.3557C83.5211 87.4525 82.0634 87.4525 81.1723 88.3557C80.2979 89.2419 80.2979 90.6663 81.1723 91.5525L85.2369 95.672C86.1877 96.6357 87.743 96.6357 88.6938 95.672L97.8277 86.4148C98.7021 85.5286 98.7021 84.1043 97.8277 83.218Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8277 83.218L97.1159 83.9204L97.8277 83.218C96.9366 82.3149 95.4789 82.3149 94.5878 83.218L86.9654 90.9433L84.4122 88.3557C83.5211 87.4525 82.0634 87.4525 81.1723 88.3557C80.2979 89.2419 80.2979 90.6663 81.1723 91.5525L85.2369 95.672C86.1877 96.6357 87.743 96.6357 88.6938 95.672L97.8277 86.4148C98.7021 85.5286 98.7021 84.1043 97.8277 83.218Z",
    fill: "currentColor",
    opacity: 0.4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87 51C85.2186 81.7526 56.3083 88.6219 53 89C51.4731 89.126 50 89.5 45 89.5C58.7421 83.1982 67.1221 70.3551 66.9949 61.5326C73.6114 62.0367 83.6917 62.4692 87 51Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87 51C85.2186 81.7526 56.3083 88.6219 53 89C51.4731 89.126 50 89.5 45 89.5C58.7421 83.1982 67.1221 70.3551 66.9949 61.5326C73.6114 62.0367 83.6917 62.4692 87 51Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperTasks);
export default __webpack_public_path__ + "static/media/paperTasks.94b83e6cbac5902e19098a8dedd80746.svg";
export { ForwardRef as ReactComponent };